const DotGridSvg = ({
  height = 32,
  width = 10,
  viewBox = '0 0 10 32',
}: {
  height?: number;
  width?: number;
  viewBox?: string;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <rect width="4" height="4" fill="#F54900" />
      <rect y="6" width="4" height="4" fill="#F54900" />
      <rect y="12" width="4" height="4" fill="#F54900" />
      <rect y="18" width="4" height="4" fill="#F54900" />
      <rect y="24" width="4" height="4" fill="#F54900" />

      <rect x="6" width="4" height="4" fill="#F54900" />
      <rect x="6" y="6" width="4" height="4" fill="#F54900" />
      <rect x="6" y="12" width="4" height="4" fill="#F54900" />
      <rect x="6" y="18" width="4" height="4" fill="#F54900" />
      <rect x="6" y="24" width="4" height="4" fill="#F54900" />
    </svg>
  );
};

export default DotGridSvg;
